import React from "react";
import { useAuth } from "../../behavioral";
import { FilesManager } from "../../components/files-manager";
import * as Styled from "./FilesPage.styled";

export const FilesPage: React.FC = () => {
    const auth = useAuth();
    const [clientId, setClientId] = React.useState("");

    React.useEffect(() => {
        if (auth.user?.username) {
            setClientId(auth.user.username);
        }
    }, [auth.user]);

    return (
        <Styled.PageWrapper>
            {clientId ? <FilesManager clientId={clientId} /> : null}
        </Styled.PageWrapper>
    );
};
